// ApproveLoadButton
import Button from "components/Button"
import { useState } from "react"
import axios from "axios"
import { useQueryClient } from "react-query"
import { toast } from "react-toastify"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
dayjs.extend(utc)

export default (props: {
  loads: any[]
  hide?: boolean
  text?: string
  isBulk?: boolean
}) => {
  if (props.hide) return null
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)

  const calculateEndTime = (load: any): string => {
    const startTime = dayjs(load.delivery_start_time)
    const endTime = dayjs(load.delivery_end_time)
    const isValidGap =
      startTime.isValid() &&
      endTime.isValid() &&
      endTime.diff(startTime, "hours") >= 2

    return isValidGap
      ? load.delivery_end_time
      : startTime.add(2, "hours").toISOString()
  }

  const onClick = async () => {
    if (!props.loads.length) return
    try {
      setLoading(true)
      await axios.post("approve-loads/", {
        load_ids: (props.loads ?? [])?.map((load: any) => load?.id),
      })
      await Promise.allSettled(
        (props.loads ?? []).map(async (load: any) => {
          if (!load?.driver) return
          if (!dayjs(load?.delivery_end_time).isValid()) return

          const endTime = calculateEndTime(load)

          await axios.post(`event/loads/`, {
            type: "SCHEDULE_LOAD",
            load_id: load.id,
            data: {
              start_time: load?.delivery_start_time,
              end_time: endTime,
              driver_id: load.driver,
            },
          })
        })
      )

      await queryClient.invalidateQueries(["event_loads_pending"])
      toast.success(
        `${props.loads.length} Load${
          props.loads.length > 1 ? "s" : ""
        } Approved Successfully`,
        {
          position: "top-right",
          autoClose: 6000,
        }
      )
    } catch (error) {
      toast.error(`Load${props.loads.length > 1 ? "s" : ""} Approve Failed`, {
        position: "top-right",
        autoClose: 6000,
      })
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <Button
      text={props.text ?? "Approve Load"}
      loading={loading}
      onClick={onClick}
    />
  )
}
